import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";

import MainLayout from "../layouts/MainLayout/MainLayout";
import AuthLayout from "../layouts/AuthLayout/AuthLayout";

import Dashboard from "../views/Dashboard";
import LoginPage from "../views/Login";
import LeaveConfig from "../views/LeaveConfig";
import AnnualLeave from "../views/AnnualLeave";
import MyCalendar from "../views/MyCalendar";
import TeamCalendar from "../views/TeamCalendar";
import LeaveCalculator from "../views/LeaveCalculator";
import LeaveRequestView from "../views/LeaveRequestView";
import GeneralConfiguration from "../views/GeneralConfiguration";
import HistoryBalance from "../views/HistoryBalance";
import Users from "../views/Users";
import TermsAndConditions from "../views/TermsAndConditions";
import MyLeaveRequests from "../views/MyLeaveRequests";
import PendingAdministrativRequests from "../views/PendingAdministrativRequests";
import EmailAction from "../views/EmailAction";
import Profile from "../views/Profile";
import { RoleRedirectRoute } from "./RoleRedirectRoute";

export const router = createBrowserRouter([
    {
      element: <ProtectedRoute />,
      children: [
        {
          element: <MainLayout />,
          children: [
            { path: "/", element: <RoleRedirectRoute /> },
            { path: "/home", element: <RoleRedirectRoute /> },
            {
              path: "/dashboard",
              element: <Dashboard />,
            },
            {
              path: "/my-leave-requests",
              element: <MyLeaveRequests />,
            },
            {
              path: "/pending-administrativ",
              element: <PendingAdministrativRequests />,
            },
            {
              path: "/annualLeave",
              element: <AnnualLeave />,
              children: [
                {
                  index: true,
                  element: <MyCalendar />,
                },
                {
                  path: "team",
                  element: <TeamCalendar />,
                },
                {
                  path: "calculator",
                  element: <LeaveCalculator />,
                },
              ],
            },
            {
              path: "/general-configuration",
              element: <GeneralConfiguration />,
            },
            {
              path: "/general-configuration/user-management",
              element: <Users />,
            },
            {
              path: "/general-configuration/history-balance",
              element: <HistoryBalance />,
            },
            {
              path: "/general-configuration/terms-and-conditions",
              element: <TermsAndConditions />,
            },
            {
              path: "/general-configuration/configurations",
              element: <LeaveConfig />,
            },
            {
              path: "/profile",
              element: <Profile />,
            },
            {
              path: "/review/:id",
              element: <LeaveRequestView />,
            },
            {
              path: "/review-cancellation/:id",
              element: <LeaveRequestView />,
            },
          ],
        },
      ],
    },
    {
      element: <AuthLayout />,
      children: [
        {
          path: "/email-action",
          element: <EmailAction />,
        },
        {
          path: "/login",
          element: <LoginPage />,
        },
      ],
    },
  ]);
